import { useCallback } from 'react';

import { Button } from '@bambi/component-library/src/components/Button/Button';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { routeTemplateActions } from 'src/features/trip/routeTemplates/routeTemplates.slice';

export function ShowApplyRouteTemplatesModalAction() {
  const unassignedTrips = useAppSelector(
    (state) => state.dispatcher.dispatchResponse?.unassigned_trips
  );

  const dispatch = useAppDispatch();

  const showModal = useCallback(() => {
    dispatch(routeTemplateActions.setShowApplyRouteTemplatesModal(true));
  }, [dispatch]);

  return (
    <Button
      disabled={!unassignedTrips?.length}
      dataTestId="apply-route-templates-action"
      variant="ghost"
      onClick={showModal}
    >
      <span className="text-xs">Route</span>
    </Button>
  );
}
